const state = {
  token: '',
  userinfo: {}
}
const mutations = {
  set_token: (state, token) => {
    state.token = token;
  },
  set_userinfo: (state, user) => {
    state.userinfo = user;
  }
}
const actions = {
  login: function({
    commit
  }, userinfo) {
    const user = userinfo
    if (user && user.token) {
      commit('set_token', user.token)
      localStorage.setItem("token", user.token)
      commit('set_userinfo', user)
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js